import PropTypes from 'prop-types';
import React from 'react';
import IconComponent from './Icon';
import './Callout.css';

const Callout = React.memo(({ type, icon, title, text }) => (
  <section className="callout" data-callout-type={type}>
    {icon && <IconComponent src={icon} caption="-" />}
    <aside>
      {title && <h1>{title}</h1>}
      {text && <p>{text}</p>}
    </aside>
  </section>
));

Callout.propTypes = {
  type: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired
};

Callout.defaultProps = {
  type: 'default',
  icon: undefined
};

export default Callout;
